export const EVENT_LIST_TABS = ['upcoming', 'finished', 'drafts'] as const;
export type EventListTab = (typeof EVENT_LIST_TABS)[number];

// aux участника клуба (`ClubMemberDto.aux`, копия в `ParticipantDto.memberAux`): настройки
// игрока на уровне клуба, формат наш
export type MemberAux = {
  // сколько камер игрок должен включать на видеоконтроле; не указано — одна
  camerasRequired?: number;
};

// Из API и событий приходит `unknown`: что угодно, кроме объекта, считаем пустым
export function parseMemberAux(aux: unknown): MemberAux {
  if (!aux || typeof aux !== 'object' || Array.isArray(aux)) return {};
  const { camerasRequired } = aux as Record<string, unknown>;
  return typeof camerasRequired === 'number' && camerasRequired >= 1
    ? { camerasRequired: Math.floor(camerasRequired) }
    : {};
}

// Новый aux с требованием к камерам: остальные поля не трогаем; одна камера — требование
// по умолчанию, поле убираем; пустой aux — null
export function patchCamerasRequired(aux: unknown, count: number): MemberAux | null {
  const base: Record<string, unknown> =
    aux && typeof aux === 'object' && !Array.isArray(aux) ? { ...(aux as object) } : {};
  if (count > 1) base.camerasRequired = count;
  else delete base.camerasRequired;
  return Object.keys(base).length ? (base as MemberAux) : null;
}
